import React from 'react';
import { TableCell, Box, Tooltip, alpha } from '@mui/material';
import { ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';

/**
 * Componente para células de tabela com funcionalidade de ordenação
 */
const SortableTableCell = ({ column, label, orderBy, orderDirection, onSort, sx = {} }) => {
  const tooltipText = orderBy === column
    ? `Classificado por ${label} em ordem ${orderDirection === 'asc' ? 'crescente' : 'decrescente'}`
    : `Clique para classificar por ${label}`;

  return (
    <TableCell
      sx={{
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme => alpha(theme.palette.primary.main, 0.04)
        },
        backgroundColor: orderBy === column ? theme => alpha(theme.palette.primary.main, 0.08) : 'inherit',
        fontWeight: 'bold',
        color: orderBy === column ? 'primary.main' : 'inherit',
        ...sx
      }}
      onClick={() => onSort(column)}
    >
      <Tooltip title={tooltipText} placement="top" arrow>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {label}
          {orderBy === column ? (
            <Box component="span" sx={{ display: 'inline-flex', ml: 1 }}>
              {orderDirection === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
            </Box>
          ) : null}
        </Box>
      </Tooltip>
    </TableCell>
  );
};

export default SortableTableCell; 